import React, { type ReactNode, memo, useRef, useContext } from "react";
import { clsx } from "clsx";

import { useClickOutside } from "../../../../hooks/useClickOutside";
import { Context } from "../../lib/Context";

import cls from "./Menu.module.scss";

interface MenuProps {
  contextId: string;
  children?: ReactNode;
}

export const Menu = memo(({ contextId, children }: MenuProps) => {
  const _ref = useRef(null);
  const { objects, hideById } = useContext(Context);

  const menuInstance = objects.get(contextId);

  useClickOutside(_ref, () => {
    hideById(contextId);
  }, []);

  let styles;
  if (menuInstance.coords) {
    styles = {
      top: `${menuInstance.coords.clientY}px`,
      left: `${menuInstance.coords.clientX}px`,
    };
  }

  return (
    <div
      ref={_ref}
      className={clsx(cls.Menu, { [cls.isVisible]: !!menuInstance.coords })}
      data-testid="contextMenu"
      style={styles}
    >
      {!!menuInstance.coords && children}
    </div>
  );
});
